import { fetchConfig } from '@theme/utilities';
import { CartAddEvent, CartErrorEvent } from '@theme/events';

/**
 * Handles the "Reserveer nu" button click to add a hidden product to cart
 * with the kenteken as a line item property.
 */
const handleReserveButtonClick = async (event) => {
  event.preventDefault();

  const button = event.currentTarget;
  const variantId = button.dataset.hiddenProductVariantId;
  const kenteken = button.dataset.kenteken;

  if (!variantId || !kenteken) {
    console.error('Reserve button: Missing variant ID or kenteken');
    return;
  }

  // Disable button during request
  button.disabled = true;
  const originalText = button.textContent;

  try {
    // Create form data for adding to cart
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('properties[Kenteken]', kenteken);

    // Get cart sections for updating
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const cartItemComponentsSectionIds = [];
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        cartItemComponentsSectionIds.push(item.dataset.sectionId);
      }
    });
    if (cartItemComponentsSectionIds.length > 0) {
      formData.append('sections', cartItemComponentsSectionIds.join(','));
    }

    const fetchCfg = fetchConfig('javascript', { body: formData });

    const response = await fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'text/html',
      },
    });

    const data = await response.json();

    if (data.status) {
      // Error occurred
      button.dispatchEvent(
        new CartErrorEvent('', data.message, data.description, data.errors)
      );
      console.error('Reserve button error:', data.message);
    } else {
      // Success - dispatch cart add event
      button.dispatchEvent(
        new CartAddEvent({}, variantId.toString(), {
          source: 'reserve-button',
          itemCount: 1,
          productId: '10662502170970',
          sections: data.sections,
        })
      );

      // Show success feedback
      button.textContent = Theme.translations.added || 'Toegevoegd';
      setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    }
  } catch (error) {
    console.error('Reserve button error:', error);
    button.dispatchEvent(
      new CartErrorEvent('', 'Er is een fout opgetreden', '', [])
    );
  } finally {
    // Re-enable button
    button.disabled = false;
  }
};

// Initialize reserve buttons
const initializeReserveButtons = () => {
  const reserveButtons = document.querySelectorAll('[data-reserve-button]');
  reserveButtons.forEach((button) => {
    button.addEventListener('click', handleReserveButtonClick);
  });
};

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeReserveButtons);
} else {
  initializeReserveButtons();
}

// Also initialize for dynamically added content
const observer = new MutationObserver(() => {
  initializeReserveButtons();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

